<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="close()"
  >
    Close
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>

  <h2 class="cg-margin-bottom-lg cg-dialog__header">Help Questions</h2>

  <mat-dialog-content>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="How is user access granted/managed?"
    >
      <p>
        As a website access manager, you can manage users that have the same
        TIN(s) and line of business(es) (Medical and/or Behavioral) you are
        registered for.
      </p>
      <ul>
        <li>
          To assign access to users: Click on Add new user from the Manage User
          Access screen.
        </li>
        <li>
          Users can request access by clicking &quot;Register&quot; on the
          <a href="https://Provider.Evernorth.com">Provider.Evernorth.com</a>
          (for behavioral) or
          <a href="https://CignaforHCP.cigna.com">CignaforHCP.com</a> landing
          page (for medical). You will receive an email notification that they
          registered and are awaiting approval.
        </li>
        <li>
          Based on the TIN(s) and the line of business for the TIN, you may need
          to manage user access on both
          <a href="https://Provider.Evernorth.com">Provider.Evernorth.com</a>
          and <a href="https://CignaforHCP.cigna.com">CignaforHCP.com</a>; TINs
          with both medical and behavioral services can be managed on either
          site.
        </li>
      </ul>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="My organization offers both medical and behavioral services. Can I manage access for both CignaforHCP.com and Provider.Evernorth.com?"
    >
      <p>
        As a website access manager that has access to either a TIN which offers
        both medical and behavioral services or some TINs that offer medical and
        some that offer behavioral, you will be able to use a single ID and
        password to login to either website. Based on the TIN(s) and the line of
        business(es) for the TIN, you may need to manage user access on both
        <a href="https://Provider.Evernorth.com">Provider.Evernorth.com</a> and
        <a href="https://CignaforHCP.cigna.com">CignaforHCP.com</a>; TINs with
        both medical and behavioral services can be managed on either site.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="How will I know if a new user registers and is waiting for access?"
    >
      <p>
        We will send a notification to the email address we have on file. Users
        that awaiting approval can also be found on your dashboard, which is
        viewable as soon as you login to
        <a href="https://CignaforHCP.cigna.com">CignaforHCP.com</a> or
        <a href="https://Provider.Evernorth.com">Provider.Evernorth.com</a>. If
        you miss the first email notification, we will send a reminder if the
        user is still awaiting access after 15 days and a final reminder at 30
        days.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="How do I know who the website access manager(s) are for a TIN?"
    >
      <p>
        Go to Settings and Preferences, found in your name's drop-down menu in
        the top right-hand side of your screen, click on Online Access > View
        Access Rights and then select the TIN from the drop-down menu, it will
        display all of the website access managers at the bottom of the screen.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="I am incorrectly listed as a website access manager for a TIN. What should I do?"
    >
      <p>
        Another website access manager can remove the website access manager
        role by locating and selecting the user from the Manage User Access
        screen, click ‘View and edit selected users’. The ‘Delegate access and
        view delegation history report’ should be unchecked to remove the role
        of website access manager.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="How can I remove or replace an existing website access manager?"
    >
      <p>
        Only website access managers have the ability to remove or add another
        website access manager. To remove a website access manager, locate and
        select them on the Manage User Access Screen, click ‘View and edit
        selected users’. Remove the ‘Delegate access and view delegation history
        report’ entitlement to remove their access as a website access manager.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="I am a website access manager, but I can’t search for patients, claims, etc., why?"
    >
      <p>
        Some website access managers only manage access for other staff, they
        may not need access to patient or claim data. Therefore, the only
        entitlement automatically granted to the website access manager is
        ‘Delegate access and view delegation history reports’.
      </p>
      <p>
        As a website access manager, you have the ability to assign yourself
        access to the entitlements you need for your role by locating and
        selecting your name on the Manage User Access screen, click ‘View and
        edit selected users’ then add the needed entitlements.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="How do I view a list of current users?"
    >
      <p>
        The delegation history report allows you to view users tied to your Tax
        Identification Number. It includes their entitlements, last login date
        and registered contact information. This report is a helpful tool to
        assist with auditing access and help ensure users only have access to
        the content they need. To access the report, click on &quot;Delegation
        History Report&quot; from the Working with Cigna menu.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="How do I remove a user’s access?"
    >
      <p>
        You can remove a user’s access by locating and selecting the user’s
        name(s) on the Manage User Access Screen, then simply click the
        &quot;Remove Access&quot; link found in the Status column.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="What does it mean when a user is ‘disabled’?"
    >
      <p>
        When a user has not logged within in a year, they are disabled. If the
        user needs to be reactivated, they will need to contact Internet
        Customer Service at 1.800.981.9114.
      </p>
      <p>After two years, inactive users are removed.</p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="What does preferred line of business mean?"
    >
      <p>
        This field will display when the TIN(s) the user is registering for is
        tied to both medical and behavioral lines of business. The user should
        select which line of business is specific to their job role.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="My group participates in a Cigna Collaborative Care program. What steps do I take to grant reporting access?"
    >
      <p>
        It is important to assign the Clinical Reports entitlement to users that
        need iCollaborate and/or CCC reporting access.
      </p>
      <p>
        After assigning access, send an email (CC your Value-Based Service
        Executive) to
        <a href="mailto:CCCReporting@Cigna.com">CCCReporting@Cigna.com</a> for
        access to performance repots and/or
        <a href="mailto:iCollaborateFeedback@Cigna.com"
          >iCollaborateFeedback@Cigna.com</a
        >
        for access to patient-actionable information.
      </p>
      <p>Include the following in your email:</p>
      <ul>
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>The ACO TIN you used to register and name of ACO/Group</li>
        <li>
          User ID created for
          <a href="https://CignaforHCP.cigna.com">CignaforHCP.com</a> (do not
          include your password)
        </li>
        <li>
          Specifiy which role you are requesting (e.g. ECC and/or file upload
          administrator)
        </li>
      </ul>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      [expanded]="false"
      headerText="How many website access managers can be associated with a provider's TIN?"
    >
      <p>
        A TIN can have up to 15 website access managers associated it. Smaller
        providers may only use a couple website access managers, while larger
        providers with multiple locations may need up to 15.
      </p>
      <p>
        We recommend each TIN keeps a minimum of two website access managers.
      </p>
    </cigna-collapsible-item>
  </mat-dialog-content>
</div>
